import React, { useState } from "react";
import { useSharedDataContext } from '../SharedDataContext';
import MaskedInput from "react-text-mask";
import { useHistory } from 'react-router-dom';
import { centralCall } from "../../api";
import { useEffect } from "react";
import Select, { createFilter } from 'react-select';
import '../../assets/css/reactselect.css';
import { getAgeList, getMaskForNameWithMaxLength } from '../utility/utilityFunction'
import axios from 'axios';
import { useFormik } from 'formik';


const PetDetails = (props) => {
    const { sharedData, setSharedData } = useSharedDataContext();
    const [showPDetails, setShowPDetails] = useState(props.ShowPdetails);
    const [HideOwnDetails, setHideOwnDetails] = useState(props.HideOwnDetails);
    const [IsPetName, setIsPetName] = useState("");
    const [IsBreed, setIsBreed] = useState("");
    const [IsBreedCategory, setIsBreedCategory] = useState("");
    const [IsAgeYear, setIsAgeYear] = useState(null);
    const [IsAgeMonth, setIsAgeMonth] = useState("")
    const [BtnVal, setBtnVal] = useState("Continue");
    const [ErrorMSG, setErrorMSG] = useState({});
    const [IsPincode, setIsPincode] = useState("");
    const [IsGender, setIsGender] = useState('Male');
    const [IsWeight, setIsWeight] = useState(null);
    const [breedList, setBreedList] = useState([]);
    const [addonList, setAddonList] = useState({
        ThirdPartyLiabilityCover: false,
        PersonalBelongingsCover: false,
        EmergencyPetMindingCover: false,
        VeteneryConsultationOrDoctorOnCallCover: false,
        FuneralCostCover: false,
        TerminalDiesease: false,
        LongTermCover: false,
    })

    const initialValues = {
        petname: '',
        breed: '',
        breedCategory: '',
        ageYear: null,
        ageMonth: '',
        pincode: '',
        gender: 'Male',
        weight: '',
        breedList: [],
        btnVal: 'View Quotes',
        ageListData: { monthList:[], yearList:[] },
    }

    const validateForm = (values) => {
        const { petname, breed, breedCategory, ageYear, ageMonth, pincode, gender, weight, breedList, btnVal, ageListData } = values;

        let ErrorMSG = {};
        if (petname.trim() === "") {
            ErrorMSG["petname"] = "Enter your pet name.";
        } else if (petname.trim().length < 2) {
            ErrorMSG['petname'] = 'Enter valid pet name.'
        }
        if (breed === "" || breed === undefined || breed === null) {
            ErrorMSG["breed"] = "Select breed of your pet.";

        }
        if (breedCategory === "" || breedCategory === undefined || breedCategory === null) {
            ErrorMSG["breedCategory"] = "Select breed category of your pet.";

        }
        if (ageYear === "" || ageYear === undefined || ageYear === null) {
            ErrorMSG["ageYear"] = "Select age year of your pet.";
        } else if (ageYear == "0 Year" && ageMonth == "") {
            ErrorMSG["ageMonth"] = "Select age month of your pet.";
        }
        if (ageMonth == '' || ageMonth === undefined || ageMonth === null) {
            ErrorMSG["ageMonth"] = "Select age month of your pet.";
        }
        if (gender === "" || gender === undefined || gender === null) {
            ErrorMSG["gender"] = "Select gender of your pet.";
        }
        if (weight === "" || weight === undefined || weight === null) {
            ErrorMSG["weight"] = "Enter weight of your pet.";
        } else{
            const Weight = parseInt(weight);
            if (Weight == 0 || Weight < 1) {
                ErrorMSG['weight'] ='Enter valid weight of your pet.'
            }
        }
        if (ageYear && weight) {
            if ((ageYear.split(" ")[0] > 7 && weight > 40) || (ageYear.split(" ")[0] == 7 && ageMonth.split(" ")[0] > 0 && weight > 40)) {
                ErrorMSG["weight"] = "Pets exceeding 40 kg in weight can be insured up to the age of 7 years.";
            }
        }
        if (pincode === "") {
            ErrorMSG["pincode"] = "Enter PIN code.";
        } else if (pincode.length !== 6) {
            ErrorMSG["pincode"] = "Enter valid PIN code.";
        }

        return ErrorMSG;
    }

    const { values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit, setFieldTouched } = useFormik({
        initialValues,
        validate: validateForm,
        onSubmit: (values) => {
            viewQuotes();
        }
    })


    const history = useHistory();

    useEffect(() => {
        //fetchBreedList()
        centralCall({ URL: "/api/Binding/GetBreedList", IsPost: false })
            .then(Res => {
                if (Res.status === 200 && Res.data.StatusCode === "200")
                    setBreedList(Res.data.Data);
                setSharedData(prev => ({ ...prev, breedList: Res.data.Data }));
            })
            .catch(error => {
                console.error('Error fetching breed list:', error);
            });
    }, []);



  

    useEffect(() => {
        bindCityStateNameByPin();
    }, [values?.pincode]);

    const bindCityStateNameByPin = () => {

        if (values?.pincode?.length === 6) {
            centralCall({ URL: `/api/Binding/GetStateCityListByPincode?pincode=${values?.pincode}` }).then(res => {
                if (res.data.StatusCode == "200") {
                    const data = res.data.Data[0];
                    setSharedData({ ...sharedData, stateName: data.State, cityName: data.City });
                    //if (data) { setErrorMSG({ ...ErrorMSG, pincode: "" }); }
                }
            });

        } else {
            setSharedData({ ...sharedData, stateName: "", cityName: "" });
        }
    }

    const handleIsWeight = (selectedweight) => {
        //setIsWeight(selectedweight);
        setFieldValue('weight', selectedweight);
        if (parseInt(selectedweight) <= 10) {
           // setIsBreedCategory("Small");
            setFieldValue('breedCategory', 'Small');
        } else if (parseInt(selectedweight) <= 25 && parseInt(selectedweight) > 10) {
            //setIsBreedCategory("Medium");
            setFieldValue('breedCategory', 'Medium');
        }
        else if (parseInt(selectedweight) <= 40 && parseInt(selectedweight) > 25) {
            //setIsBreedCategory("Large");
            setFieldValue('breedCategory', 'Large');
        }
        else if (parseInt(selectedweight) > 40) {
            //setIsBreedCategory("Giant");
            setFieldValue('breedCategory', 'Giant');
        }

    }

    const handleBreedChange = (selectedBreedName) => {
       // setIsBreed(selectedBreedName);
        setFieldValue('breed', selectedBreedName)
    };
    const findUserID = async () => {
        let user = 0;
        if (window.localStorage.getItem("token")) {
            await axios.post("https://crmapi.smcinsurance.com:8081/api/User/GetUserInfo", {
                Token: JSON.parse(window.localStorage.getItem("token")).token
            })
                .then((res) => {
                    user = res.data.userID
                });
        }
        return user;
    }
    const GotoQuote = async (e) => {
        e.preventDefault();
        let ErrorMSG = {};
        let goto = true;
        if (IsPetName.trim() === "") {
            ErrorMSG["IsPetName"] = "Enter your pet name.";
            goto = false;
        }
        if (IsBreed === "" || IsBreed === undefined || IsBreed === null) {
            ErrorMSG["IsBreed"] = "Select breed of your pet.";
            goto = false;
        }
        if (IsBreedCategory === "" || IsBreedCategory === undefined || IsBreedCategory === null) {
            ErrorMSG["IsBreedCategory"] = "Select breed category of your pet.";
            goto = false;
        }
        if (IsAgeYear === "" || IsAgeYear === undefined || IsAgeYear === null) {
            ErrorMSG["IsAgeYear"] = "Select age year of your pet.";
            goto = false;
        } else if (IsAgeYear == "0 Year" && IsAgeMonth == "") {
            ErrorMSG["IsAgeMonth"] = "Select age month of your pet.";
            goto = false;
        }
        if (IsGender === "" || IsGender === undefined || IsGender === null) {
            ErrorMSG["IsGender"] = "Select gender of your pet.";
            goto = false;
        }
        if (IsWeight === "" || IsWeight === undefined || IsWeight === null) {
            ErrorMSG["IsWeight"] = "Enter weight of your pet.";
            goto = false;
        }
        if (IsAgeYear && IsWeight) {
            if ((IsAgeYear.split(" ")[0] > 7 && IsWeight > 40) || (IsAgeYear.split(" ")[0] == 7 && IsAgeMonth.split(" ")[0] > 0 && IsWeight > 40)) {
                ErrorMSG["IsWeight"] = "Pets exceeding 40 kg in weight can be insured up to the age of 7 years.";
                goto = false;
            }
        }
        if (IsPincode === "") {
            ErrorMSG["IsPincode"] = "Enter PIN code.";
            goto = false;
        } else if (IsPincode.length !== 6) {
            ErrorMSG["IsPincode"] = "Enter valid PIN code.";
            goto = false;
        }

        setErrorMSG(ErrorMSG);

        if (goto) {
            setBtnVal("Wait...")


            const updateddata = {
                ...sharedData,
                petname: IsPetName,
                petbreed: IsBreed,
                breedCategory: IsBreedCategory,
                petage: IsAgeYear,
                petagemonth: IsAgeMonth,
                pincode: IsPincode,
                petgender: IsGender,
                petweight: IsWeight,
                enquiryno: '',
            }
            setSharedData(updateddata);
            const userid = await findUserID();
            var enqmodel = {
                "MobileNo": sharedData.mobileno,
                "LeadSource": "pet",
                "UserId": userid,
                LotNo: "lkjhh",
                BusinessID: window.localStorage.getItem("BusinessID")

            }
            centralCall({ URL: "/api/Quotation/GetEnquiryNo", Request: enqmodel, IsPost: true })
                //fetchEnquiry(enqmodel)
                .then(Res => {
                    const { AddonsSelected, medicalDetailsObj, ownerDetailsObj, petDetailsObj, proposalmodel, ...rest } = sharedData;
                    if (Res.status === 200 && Res.data.StatusCode === "200") {
                        const updateddata1 = {
                            ...rest,
                            petname: IsPetName,
                            petbreed: IsBreed,
                            breedCategory: IsBreedCategory,
                            petage: IsAgeYear,
                            petagemonth: IsAgeMonth,
                            pincode: IsPincode,
                            petgender: IsGender,
                            petweight: IsWeight,
                            enquiryno: Res.data.Data,
                            AddonsSelected: addonList
                        }
                        setSharedData(updateddata1);
                        history.push("/quote", sharedData);

                        setHideOwnDetails(false);
                        setShowPDetails(true);
                    } else {
                        setBtnVal("Continue")
                    }
                });
        }
    }

    const viewQuotes = async () => {
        const { petname, breed, breedCategory, ageYear,gender, ageMonth, pincode, weight } = values;
        setBtnVal("Wait...")
        setFieldValue('btnVal', 'Wait...');

        const updateddata = {
            ...sharedData,
            petname: petname,
            petbreed: breed,
            breedCategory: breedCategory,
            petage: ageYear,
            petagemonth: ageMonth,
            pincode: pincode,
            petgender: gender,
            petweight: weight,
            enquiryno: '',
        }
        setSharedData(updateddata);
        const userid = await findUserID();
        var enqmodel = {
            "MobileNo": sharedData.mobileno,
            "LeadSource": "pet",
            "UserId": userid,
            LotNo: "lkjhh",
            BusinessID: window.localStorage.getItem("BusinessID")

        }
        centralCall({ URL: "/api/Quotation/GetEnquiryNo", Request: enqmodel, IsPost: true })
            //fetchEnquiry(enqmodel)
            .then(Res => {
                const { AddonsSelected, medicalDetailsObj, ownerDetailsObj, petDetailsObj, proposalmodel, ...rest } = sharedData;
                if (Res.status === 200 && Res.data.StatusCode === "200") {
                    const updateddata1 = {
                        ...rest,
                        petname: petname,
                        petbreed: breed,
                        breedCategory: breedCategory,
                        petage: ageYear,
                        petagemonth: ageMonth,
                        pincode: pincode,
                        petgender: gender,
                        petweight: weight,
                        enquiryno: Res.data.Data,
                        AddonsSelected: addonList
                    }
                    setSharedData(updateddata1);
                    history.push("/quote", sharedData);

                    setHideOwnDetails(false);
                    setShowPDetails(true);
                } else {
                    //setBtnVal("Continue");
                    setFieldValue('btnVal', 'View Quotes');
                }
            });
    }


   

    const handleAgeYear = (e) => {
        //setIsAgeYear(e.target.value);
        setFieldValue('ageYear', e.target.value);
        if ((e.target.value?.split(" ")[0] == 0 && values.ageMonth?.split(" ")[0] < 2) || (e.target.value?.split(" ")[0] == 10)) {
            //setIsAgeMonth("");
            setFieldValue('ageMonth', '');
        }
        if (e.target.value?.split(" ")[0] == 10) {
            //setIsAgeMonth("0 Month");
            setFieldValue('ageMonth', '0 Month');
        }
    }

    useEffect(() => {
        if (sharedData.petname) setFieldValue('petname',sharedData.petname);
        if (sharedData.petbreed) setFieldValue('breed',sharedData.petbreed);
        if (sharedData.petagemonth) setFieldValue('ageMonth', sharedData.petagemonth);
        if (sharedData.petage) setFieldValue('ageYear', sharedData.petage);
        if (sharedData.petgender) setFieldValue('gender', sharedData.petgender);
        if (sharedData.pincode) setFieldValue('pincode', sharedData.pincode);
        if (sharedData.petweight) {
            setIsWeight(sharedData.petweight);
            handleIsWeight(sharedData.petweight);
            setFieldValue('petweight', sharedData.petweight);
            handleIsWeight(sharedData.petweight);
        }
    }, [])

    // console.log({ IsAgeMonth });

    useEffect(() => {
        let isMounted = true;
        let monthList = getAgeList(false);
        let yearList = getAgeList(true);
        if (isMounted) {
            setFieldValue('ageListData', { monthList, yearList });
        }

        return () => {
            isMounted = false;
        }
    }, []);

    const filterConfig = {
        trim: true,
        matchFrom: true ? 'start' : 'any',
    };

    return (
        <div className="SameForm SameForm2 ">
            <div className="BackHead">
                <span onClick={() => props.goback()} className="formHeading backBtn"><i className="fas fa-long-arrow-alt-left"></i> Owner Details : <span className="CapitalizeName">{sharedData.ownername},  {sharedData.mobileno}</span></span>
            </div>
            <p className="formHeading petDetails">Pet Details</p>
            <div className="PetInput">
                <MaskedInput
                    mask={getMaskForNameWithMaxLength(50)}
                    guide={false} showMask={false}
                    onKeyDown={(e) => {
                        // Prevent typing multiple consecutive spaces
                        const { value, selectionStart } = e.target;
                        if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        // Ensure no leading spaces or multiple spaces
                        const processedValue = e.target.value
                            .replace(/^\s+/, '') // Remove leading spaces
                            .replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space

                        setFieldValue('petname', processedValue);
                    }}
                    onBlur={() => setFieldTouched('petname', true)}
                    value={values?.petname}
                    placeholder=" " id="ForUp1" className="InputBox"
                />
                <label htmlFor="ForUp1" className="floating_label">Pet Name</label>
                <div className="inputIcon">
                    <img src={require("../../assets/images/dog.svg").default} alt="" />
                </div>
                {(touched.petname && errors.petname) && <span className="Error">{errors["petname"]}</span>}
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="PetInput">
                        <Select
                            inputId="petBreed"
                            value={values?.breed ? { label: values.breed, value: values.breed } : null}
                            options={breedList?.map(breed => ({ label: breed?.Breed, value: breed?.Breed }))}
                            onChange={(selectedOption) => handleBreedChange(selectedOption?.value)}
                            placeholder="Select Pet Breed" className="InputBox"
                            isSearchable
                            filterOption={createFilter(filterConfig)}
                            onBlur={() => setFieldTouched('breed',true)}
                        />
                        <label htmlFor="petBreed" className="floating_label petBreedLabel">Select Breed</label>
                        {(touched.breed && errors.breed) && <span className="Error">{errors["breed"]}</span>}
                    </div>
                </div>
            </div>

            <div className="Pet_ageBox row">
                <div className="pet_age col-md-6">
                    <div className="PetInput">
                        <select className="InputBox SpaceInPlaceHolder" value={values?.ageYear} name='ageYear' onBlur={handleBlur} onChange={(e) => handleAgeYear(e)}>
                            <option value="">Select Age</option>
                            {values?.ageListData?.yearList?.map((age, ind) => (<option key={ind} value={age.value}>{age.value}</option>))}

                        </select>
                        <label>Select Pet Age (year)</label>
                        {(touched.ageYear && errors.ageYear) && <span className="Error">{errors["ageYear"]}</span>}
                    </div>
                </div>
                <div className="pet_age col-md-6">
                    <div className="PetInput">
                        <select className="InputBox SpaceInPlaceHolder" value={values?.ageMonth} onBlur={handleBlur} onChange={(e) => setFieldValue('ageMonth', e.target.value)}>
                            <option value="">Select Age</option>
                            {values?.ageListData?.monthList?.map((age, ind) => values?.ageYear?.split(" ")[0] == 0 ? (age?.value?.split(" ")[0] > 2) && <option key={ind} value={age.value}>{age.value}</option> : values?.ageYear?.split(" ")[0] == 10 ? (age.value.split(" ")[0] == 0) && <option key={ind} value={age.value}>{age.value}</option> : <option key={ind} value={age.value}>{age.value}</option>)}
                        </select>
                        <label>Select Pet Age (month)</label>
                        {(errors.ageMonth && touched.ageMonth) && <span className="Error">{errors["ageMonth"]}</span>}
                    </div>
                </div>
            </div>
            <div className="row mt-0">
                <div className="col-md-6">
                    <label>Select Pet Gender</label>
                    <div className="d-flex ">
                        <div className="me-2">
                            <input className="" type="radio" name="gender" value="Male" id="Male" checked={values?.gender == "Male"} onBlur={handleBlur} onChange={(e) => setFieldValue("gender",e.target.value)} />
                            <label className="form-check-label mx-1" htmlFor="Male">
                                Male
                            </label>
                        </div>
                        <div className="">
                            <input className="" type="radio" name="gender" id="Female" value="Female" checked={values?.gender == "Female"} onBlur={handleBlur} onChange={(e) => setFieldValue("gender", e.target.value)} />
                            <label className="form-check-label mx-1" htmlFor="Female">
                                Female
                            </label>
                        </div>
                    </div>
                    {(errors.gender && touched.gender) && <span className="Error">{errors["gender"]}</span>}
                </div>
                <div className="col-md-6 mt-3">
                    <div className="PetInput">
                        <MaskedInput type="text"
                            mask={[/[0-9]/, /\d/]}
                            guide={false} showMask={false} placeholder=" " value={values?.weight} name='weight' onBlur={handleBlur} onChange={(e) => handleIsWeight(e.target.value)} id="ForUp20" className="InputBox" />
                        {values.weight && <span class="weight_unit">KG</span>}
                        <label htmlFor="ForUp20">Pet Weight</label>
                        {(errors.weight && touched.weight) && <span className="Error">{errors["weight"]}</span>}
                    </div>
                </div>
            </div>

            <div className="PetInput mt-2">
                <MaskedInput type="tel"
                    mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                    guide={false} showMask={false} placeholder=" " value={values?.pincode} name='pincode' onChange={handleChange} onBlur={handleBlur} id="ForUp2" className="InputBox" />
                <div className="inputIcon">
                    <img src={require("../../assets/images/location.svg").default} alt="" />
                </div>
                <label htmlFor="ForUp2" className="floating_label">PIN Code</label>
                {(sharedData.stateName && sharedData.cityName && values.pincode.length === 6) && <span className="city_state_name">{sharedData.cityName}, {sharedData.stateName}</span>}
                {(errors.pincode && touched.pincode)&&<span className="Error">{errors["pincode"]}</span>}
            </div>
            <button className="SMCBTN" id="quotesBtn" onClick={handleSubmit} name="Member">{BtnVal}</button>
            <div className="TandCPro d-flex  mt-2 TnCBtn">
                <span>By continuing, I agree to all <a href="/terms-of-use" target="_blank">T&C</a></span>
            </div>
        </div>
    )
}
export default PetDetails;